import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { SafelySetInnerHTML } from "@faire/web--source/common/SafelySetInnerHTML";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
export var BuilderTypography = function(_param) {
    var textContent = _param.textContent, attributes = _param.attributes, props = _object_without_properties(_param, [
        "textContent",
        "attributes"
    ]);
    return /*#__PURE__*/ _createElement(Typography, _object_spread_props(_object_spread({}, props), {
        style: attributes.style,
        className: attributes.className,
        key: attributes.key,
        "builder-id": attributes["builder-id"]
    }), /*#__PURE__*/ _jsx(SafelySetInnerHTML, {
        html: textContent
    }));
};
